<template>
  <div class="success-page">
    <div class="icon-area">
      <van-icon name="checked" size="80" color="#07c160" />
    </div>
    <h2>Schedule Submitted</h2>
    <p class="message">{{ message }}</p>
    <div class="action-area">
      <van-button round block type="info" style="margin-bottom: 12px" @click="viewMyRequests">
        View My Requests
      </van-button>
      <van-button round block plain type="info" @click="goBack">
        Submit Another Schedule
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubmitSuccess",
  computed: {
    message() {
      return (
        this.$route.query.msg ||
        "Your schedule has been sent to the department manager."
      );
    },
  },
  methods: {
    goBack() {
      const query = {
        hotel: this.$route.query.hotel,
      };
      if (this.$route.query.user) {
        query.user = this.$route.query.user;
      }
      if (this.$route.query.login === "1") {
        query.login = "1";
      }
      this.$router.replace({
        name: "ScheduleRequest",
        query,
      });
    },
    viewMyRequests() {
      const query = {
        hotel: this.$route.query.hotel,
      };
      if (this.$route.query.user) {
        query.user = this.$route.query.user;
      } else if (this.$route.query.login === "1") {
        query.login = "1";
      } else {
        query.employeeName = this.$route.query.employeeName;
        query.hotelDeptId = this.$route.query.hotelDeptId;
        query.deptName = this.$route.query.deptName;
      }
      this.$router.replace({
        name: "ScheduleRecords",
        query,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 30px 30px;
  text-align: center;

  .icon-area {
    margin-bottom: 20px;
  }

  h2 {
    margin: 0 0 12px;
    font-size: 22px;
    color: #333;
  }

  .message {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 40px;
  }

  .action-area {
    width: 100%;
    max-width: 300px;
  }
}
</style>
